import { render, staticRenderFns } from "./involvedFamilyChat.vue?vue&type=template&id=332f5e57&"
import script from "./involvedFamilyChat.vue?vue&type=script&lang=js&"
export * from "./involvedFamilyChat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports